import { render } from "./NcrmAddToBoardDrawer.vue?vue&type=template&id=336af6b1"
import script from "./NcrmAddToBoardDrawer.vue?vue&type=script&lang=js"
export * from "./NcrmAddToBoardDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__